import { FaSun } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatBrightnessSubtitle } from "./installationBrightnessUtils";
import { InstallationPickerRow } from "./InstallationPickerSheet";

const InstallationBrightnessSection = ({
  routeCameraId,
  configData,
  disabled,
  divided,
  adminOnly = false,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <InstallationPickerRow
      icon={FaSun}
      iconVariant="brightness"
      title={t("installation_brightness_row_title")}
      subtitle={formatBrightnessSubtitle(t, configData)}
      onClick={() =>
        history.push(
          `/app/installationdetails/${routeCameraId}/visualization/brightness`,
        )
      }
      disabled={disabled}
      divided={divided}
      adminOnly={adminOnly}
    />
  );
};

export default InstallationBrightnessSection;
